import React from 'react';
import { Layout } from 'antd';
import PropTypes from 'prop-types';
import './style.css';

const PageContainer = props => (
  <Layout className="page-container">{props.children || []}</Layout>
);

PageContainer.defaultProps = {
  children: [],
};

PageContainer.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]),
};

export default PageContainer;
